import { render, staticRenderFns } from "./Pendentes.vue?vue&type=template&id=11f7e3f8&scoped=true&"
import script from "./Pendentes.vue?vue&type=script&lang=js&"
export * from "./Pendentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f7e3f8",
  null
  
)

export default component.exports